import './ui/styles.css';
import { mount } from './ui/app';

mount(document.getElementById('app') as HTMLElement);
